import { render, staticRenderFns } from "./DataTableActualizarServicioTransbordo.vue?vue&type=template&id=183a99ad"
import script from "./DataTableActualizarServicioTransbordo.vue?vue&type=script&lang=js"
export * from "./DataTableActualizarServicioTransbordo.vue?vue&type=script&lang=js"
import style0 from "./DataTableActualizarServicioTransbordo.vue?vue&type=style&index=0&id=183a99ad&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports